import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { TcsmStates } from '../../root/tcsm-model';
import { GenerateGroupsQuickNavMenu } from '../constants/navigation-lists';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { DropdownNavigation } from './dropdown-navigation';

export interface Props {
	basePath: string;
}

export const GroupsNav = (props: Props) => {

	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
	const navOptions = GenerateGroupsQuickNavMenu(props.basePath, language, siteSettings);
	const location = useLocation();

	const pathName = location.pathname.toLocaleLowerCase();

	if (!navOptions.some(a => 
		(a.value?.length > 0 && pathName === a.value?.toLocaleLowerCase()) || 
		(a.fallbackMatch?.length > 0 && pathName === a.fallbackMatch?.toLocaleLowerCase()))) {
		return null;
	}

	return (
		<DropdownNavigation options={navOptions} />
	);
};